import { compareAsc } from 'date-fns'
import { customizeError } from '@chilecompra/react-kit/errors'
import { formatDate, formatDNI, formatPercentage } from '@chilecompra/react-kit/utils'
import { makeActionCreator } from '../../config/store/utils'
import { getDatesAwarded, getSellerCertificate, getSellerCertificateOld } from '../../services/partnerships'
import { REACT_APP_DATES_PRODUCTION_STU } from '../../config/settings/environment'

const mechanismDictionary = {
  1: 'tender',
  2: 'purchase-order'
}
const sourceDictionary = {
  0: 'boardOfTrade',
  1: 'affidavit'
}

export const GET_SELLER_PARTNERSHIP_CERTIFICATE = 'GET_SELLER_PARTNERSHIP_CERTIFICATE'
export const GET_SELLER_PARTNERSHIP_CERTIFICATE_ERROR = 'GET_SELLER_PARTNERSHIP_CERTIFICATE_ERROR'
export const GET_SELLER_PARTNERSHIP_CERTIFICATE_SUCCESS = 'GET_SELLER_PARTNERSHIP_CERTIFICATE_SUCCESS'
export const onGetSellerPartnershipCertificate = makeActionCreator(GET_SELLER_PARTNERSHIP_CERTIFICATE)
export const onGetSellerPartnershipCertificateError = makeActionCreator(
  GET_SELLER_PARTNERSHIP_CERTIFICATE_ERROR,
  'payload'
)
export const onGetSellerPartnershipCertificateSuccess = makeActionCreator(
  GET_SELLER_PARTNERSHIP_CERTIFICATE_SUCCESS,
  'payload'
)
export const onGetSellerPartnershipCertificateThunk = payload => async dispatch => {
  dispatch(onGetSellerPartnershipCertificate())

  try {
    const { data } = await getSellerCertificate({
      organizationCode: payload.organizationCode || '529775',
      processType: payload.processType || '1',
      purchaseMechanismId: payload.purchaseMechanismId || '8677227',
      bidID: payload.bidID || null
    })

    if (!data.payload) {
      throw customizeError({ code: 200, originalError: data, reason: 'Payload is NULL' })
    }

    const certificate = {
      completed: data.payload?.estado === 1,
      dates: {
        accepted:
          data.payload?.fechaAceptacionOC &&
          formatDate(data.payload?.fechaAceptacionOC, "dd 'de' MMMM 'de' yyyy HH:mm"),
        awarded:
          data.payload?.fechaAdjudicacionLC &&
          formatDate(data.payload?.fechaAdjudicacionLC, "dd 'de' MMMM 'de' yyyy HH:mm"),
        generated: data.payload?.fechaGeneraCertif && formatDate(data.payload?.fechaGeneraCertif, 'dd/MM/yyyy')
      },
      dni: data.payload?.rut && formatDNI(data.payload?.rut),
      failed: data.payload?.estado === 2,
      hasAgreement: false,
      mechanismName: data.payload?.procedenciaOrdenCompra,
      mechanismType: mechanismDictionary[data.payload?.idTipoMecanismoProceso || 1],
      businessName: data.payload?.razonSocial,
      sellers: data.payload?.proveedores.map(seller => ({
        dni: formatDNI(seller.rut),
        businessName: seller.razonSocial.replace('null', '').trim(),
        partnerships: seller.sociosYAccionistas.map(partnership => ({
          dni: formatDNI(partnership.rutSocio),
          personType: partnership.tipoPersona,
          name: partnership.nombre,
          level: partnership.nivel,
          participation: formatPercentage(partnership.participacion, 6)
        }))
      })),
      purchaseOrderID: data.payload?.ordenCompra,
      source: '',
      tenderID: data.payload?.licitacion,
      isSTU: data.payload?.esUTP === 1,
      idSTU: data.payload?.idUTP
    }

    return dispatch(onGetSellerPartnershipCertificateSuccess({ certificate }))
  } catch (error) {
    return dispatch(onGetSellerPartnershipCertificateError({ error }))
  }
}

export const onGetSellerPartnershipCertificateOldThunk = payload => async dispatch => {
  dispatch(onGetSellerPartnershipCertificate())

  try {
    const { data } = await getSellerCertificateOld({
      organizationCode: payload.organizationCode || '529775',
      processType: payload.processType || '1',
      purchaseMechanismId: payload.purchaseMechanismId || '8677227'
    })

    if (!data.payload) {
      throw customizeError({ code: 200, originalError: data, reason: 'Payload is NULL' })
    }

    const certificate = {
      completed: data.payload?.estado === 1 || data.payload?.proveedor?.estado === 1,
      dates: {
        accepted:
          data.payload?.fechaAceptacionOC &&
          formatDate(data.payload?.fechaAceptacionOC, "dd 'de' MMMM 'de' yyyy HH:mm"),
        awarded:
          data.payload?.fechaAdjudicacionLC &&
          formatDate(data.payload?.fechaAdjudicacionLC, "dd 'de' MMMM 'de' yyyy HH:mm"),
        generated: data.payload?.fechaGeneraCertif && formatDate(data.payload?.fechaGeneraCertif, 'dd/MM/yyyy')
      },
      dni: data.payload?.proveedor?.rutProveedor && formatDNI(data.payload?.proveedor?.rutProveedor),
      failed: data.payload?.estado === 2 || data.payload?.proveedor?.estado === 2,
      hasAgreement: data.payload?.proveedor?.contrato?.contrato === '1',
      mechanismName: data.payload?.procedenciaOrdenCompra,
      mechanismType: mechanismDictionary[data.payload?.idTipoMecanismoProceso || 1],
      businessName: data.payload?.proveedor?.nombreLegal,
      sellers: [
        {
          dni: formatDNI(data.payload?.proveedor?.rutProveedor),
          businessName: data.payload?.proveedor?.nombreLegal.replace('null', '').trim(),
          partnerships: data.payload?.proveedor?.sociosSociedades?.map(partnership => ({
            dni: formatDNI(partnership.rutSocio),
            personType: null,
            name: partnership.nombre.replace('null', '').trim(),
            level: null,
            participation: formatPercentage(partnership.participacion, 6)
          }))
        }
      ],
      purchaseOrderID: data.payload?.ordenCompra,
      source: sourceDictionary[data.payload?.proveedor?.generarDJ || 0],
      tenderID: data.payload?.licitacion,
      isSTU: false,
      idSTU: null
    }

    return dispatch(onGetSellerPartnershipCertificateSuccess({ certificate }))
  } catch (error) {
    return dispatch(onGetSellerPartnershipCertificateError({ error }))
  }
}

export const GET_DATES_AWARDED = 'GET_DATES_AWARDED'
export const GET_DATES_AWARDED_ERROR = 'GET_DATES_AWARDED_ERROR'
export const GET_DATES_AWARDED_SUCCESS = 'GET_DATES_AWARDED_SUCCESS'
export const onGetDatesAwarded = makeActionCreator(GET_DATES_AWARDED)
export const onGetDatesAwardedError = makeActionCreator(GET_DATES_AWARDED_ERROR, 'payload')
export const onGetDatesAwardedSuccess = makeActionCreator(GET_DATES_AWARDED_SUCCESS, 'payload')

export const onGetDatesAwardedThunk = payload => async dispatch => {
  dispatch(onGetDatesAwarded())

  try {
    const { data } = await getDatesAwarded({
      processType: payload.processType,
      purchaseMechanismId: payload.purchaseMechanismId
    })

    const dateProductionSTU = new Date(REACT_APP_DATES_PRODUCTION_STU.toString())
    const datesAwarded = new Date(data?.payload?.fechaAdjudicacionLC.toString())
    const oldCertificate = compareAsc(datesAwarded, dateProductionSTU) < 0

    if (oldCertificate) {
      dispatch(onGetSellerPartnershipCertificateOldThunk(payload))
    } else {
      dispatch(onGetSellerPartnershipCertificateThunk(payload))
    }

    dispatch(onGetDatesAwardedSuccess({ oldCertificate }))
  } catch (error) {
    dispatch(onGetDatesAwardedError({ error }))
  }
}
